"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Payments = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var banner_1 = __importDefault(require("@atlaskit/banner"));
var StripePayment_1 = require("./components/StripePayment");
var ProductSelection_1 = require("./components/ProductSelection");
var contexts_1 = require("../contexts");
var trello_1 = require("@powerupsclub/trello");
var moment_1 = __importDefault(require("moment"));
var LoadingSpinner_1 = require("./components/LoadingSpinner");
var PaymentCompleted_1 = require("./components/PaymentCompleted");
var ManageWorkspace_1 = require("./components/ManageWorkspace");
var ManageIndividual_1 = require("./components/ManageIndividual");
var tokens_1 = require("@atlaskit/tokens");
var ManagePowerUpLicense_1 = require("./components/ManagePowerUpLicense");
var getWorkspaceMembers = function (idOrg, appKey, token) { return __awaiter(void 0, void 0, void 0, function () {
    var response, workspace;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch("https://api.trello.com/1/organizations/".concat(idOrg, "/members?key=").concat(appKey, "&token=").concat(token))];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error('failed to get workspace members');
                }
                return [4 /*yield*/, response.json()];
            case 2:
                workspace = _a.sent();
                return [2 /*return*/, workspace];
        }
    });
}); };
var Payments = function (_a) {
    var onComplete = _a.onComplete, onDismiss = _a.onDismiss;
    var _b = (0, react_1.useState)('workspace'), selectedProduct = _b[0], setSelectedProduct = _b[1];
    var _c = (0, react_1.useContext)(contexts_1.PaymentsContext), subscription = _c.subscription, paymentsIsLoading = _c.isLoading, trialEndDate = _c.trialEndDate, dismissPaymentModal = _c.dismissPaymentModal;
    var _d = (0, react_1.useContext)(trello_1.TrelloPowerUpContext), org = _d.org, token = _d.token, appKey = _d.appKey, trelloIsLoading = _d.isLoading, trelloIframe = _d.trelloIframe, appName = _d.appName, powerUpKey = _d.powerUpKey;
    var _e = (0, react_1.useState)([]), workspaceMembers = _e[0], setWorkspaceMembers = _e[1];
    var _f = (0, react_1.useState)(true), isLoadingMembers = _f[0], setIsLoadingMembers = _f[1];
    var _g = (0, react_1.useState)(false), paymentCompleted = _g[0], setPaymentCompleted = _g[1];
    var isLoading = isLoadingMembers || trelloIsLoading || paymentsIsLoading;
    var trialEnded = trialEndDate ? new Date() > trialEndDate : false;
    var hasSubscription = (subscription === null || subscription === void 0 ? void 0 : subscription.status) === 'active';
    (0, react_1.useEffect)(function () {
        var _a, _b;
        var accentColor = (0, tokens_1.getTokenValue)('elevation.surface', '#ffffff');
        if (isLoading) {
            var context = trelloIframe.getContext();
            var theme = (_b = (_a = context.theme) !== null && _a !== void 0 ? _a : context.initialTheme) !== null && _b !== void 0 ? _b : 'light';
            if (theme === 'dark') {
                accentColor = '#1D2125';
            }
        }
        trelloIframe.updateModal({
            accentColor: accentColor
        });
    }, [trelloIframe, isLoading]);
    (0, react_1.useEffect)(function () {
        if (powerUpKey) {
        }
    }, [powerUpKey]);
    (0, react_1.useEffect)(function () {
        var loadOrgDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
            var members, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setIsLoadingMembers(true);
                        if (!(org && token)) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getWorkspaceMembers(org.id, appKey, token)];
                    case 2:
                        members = _a.sent();
                        if ((members === null || members === void 0 ? void 0 : members.length) > 0) {
                            setWorkspaceMembers(members);
                        }
                        else {
                            setSelectedProduct('individual');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        setSelectedProduct('individual');
                        return [3 /*break*/, 4];
                    case 4:
                        setIsLoadingMembers(false);
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        loadOrgDetails();
    }, [org, token]);
    if (isLoading) {
        return (0, jsx_runtime_1.jsx)(LoadingSpinner_1.LoadingSpinner, {}, void 0);
    }
    function renderContent() {
        var _a, _b, _c, _d;
        if (paymentCompleted) {
            return ((0, jsx_runtime_1.jsx)(PaymentCompleted_1.PaymentCompleted, { onComplete: function () {
                    if (onComplete) {
                        onComplete();
                    }
                    else {
                        trelloIframe.closeModal();
                    }
                } }, void 0));
        }
        var paymentForm = ((0, jsx_runtime_1.jsx)(StripePayment_1.StripePayment, { setSelectedProduct: setSelectedProduct, numberOfWorkspaceMembers: workspaceMembers.length, selectedProduct: selectedProduct, onComplete: function () {
                setPaymentCompleted(true);
            }, onContinueTrial: !trialEnded
                ? function () {
                    dismissPaymentModal();
                    onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                }
                : undefined }, void 0));
        if (selectedProduct === 'workspace') {
            return subscription.workspace ? ((0, jsx_runtime_1.jsx)(ManageWorkspace_1.ManageWorkspace, { numberOfWorkspaceMembers: workspaceMembers.length }, void 0)) : (paymentForm);
        }
        if (selectedProduct === 'individual') {
            return subscription.individual ? (0, jsx_runtime_1.jsx)(ManageIndividual_1.ManageIndividual, {}, void 0) : paymentForm;
        }
        if (selectedProduct === 'powerup') {
            return ((_b = (_a = subscription[powerUpKey]) === null || _a === void 0 ? void 0 : _a.individual) === null || _b === void 0 ? void 0 : _b.status) === 'active' ||
                ((_d = (_c = subscription[powerUpKey]) === null || _c === void 0 ? void 0 : _c.workspace) === null || _d === void 0 ? void 0 : _d.status) === 'active' ? ((0, jsx_runtime_1.jsx)(ManagePowerUpLicense_1.ManagePowerUpLicense, { numberOfWorkspaceMembers: workspaceMembers.length }, void 0)) : (paymentForm);
        }
    }
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ style: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: trelloIframe.getComputedColorToken('elevation.surface', '#ffffff'),
            height: '100vh'
        } }, { children: [!hasSubscription && ((0, jsx_runtime_1.jsx)("div", __assign({ style: { minHeight: '51px' } }, { children: trialEnded ? ((0, jsx_runtime_1.jsx)(banner_1["default"], __assign({ appearance: "announcement", isOpen: true }, { children: trelloIframe.localizeKey('your-free-trial-has-ended', {
                        appName: appName
                    }) }), void 0)) : ((0, jsx_runtime_1.jsxs)(banner_1["default"], __assign({ appearance: "warning", isOpen: true }, { children: [trelloIframe.localizeKey('your-free-trial-ends-in', {
                            trialEndDateFromNow: (0, moment_1["default"])(trialEndDate).fromNow(),
                            appName: appName
                        }), ' ', (0, jsx_runtime_1.jsx)("a", __assign({ href: "#", onClick: function (e) {
                                e.preventDefault();
                                dismissPaymentModal();
                                onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
                            } }, { children: trelloIframe.localizeKey('continue-with-free-trial') }), void 0)] }), void 0)) }), void 0)), (0, jsx_runtime_1.jsxs)("div", __assign({ style: {
                    display: 'flex',
                    flexGrow: 1
                } }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ style: {
                            flexGrow: 1,
                            width: '50%',
                            padding: '16px'
                        } }, { children: (0, jsx_runtime_1.jsx)(ProductSelection_1.ProductSelection, { disableWorkspaceLicense: workspaceMembers.length === 0, selectedProduct: selectedProduct, onProductChange: function (product) { return setSelectedProduct(product); } }, void 0) }), void 0), (0, jsx_runtime_1.jsx)("div", __assign({ style: {
                            borderLeft: "1px solid ".concat(trelloIframe.getComputedColorToken('color.border', '#eeeeee')),
                            flexGrow: 1,
                            width: '50%',
                            padding: '16px',
                            position: 'relative'
                        } }, { children: renderContent() }), void 0)] }), void 0)] }), void 0));
};
exports.Payments = Payments;
//# sourceMappingURL=Payments.js.map